export default __webpack_public_path__ + "static/media/solidity.9a07f18c.svg";